import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecepcaoRoutingModule } from './recepcao-routing.module';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { AgendamentoEspecialidadeComponent } from './agendamento-especialidade/agendamento-especialidade.component';


@NgModule({
  declarations: [
    AgendamentoEspecialidadeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,

    DropdownModule,
    CalendarModule,
    DialogModule,
    TableModule,
    ListboxModule,
    CheckboxModule,
    InputTextModule,
    InputMaskModule,
    TooltipModule,

    RecepcaoRoutingModule,
  ]
})
export class RecepcaoModule { }
